import baseDataStore from './baseDataStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.baseData) {
      store.registerModule(['base', 'baseData'], baseDataStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'baseData']);
  },
};
